import { TemplateStruct, TemplateStructRow, TemplateStructCol } from "@/models/Blocks/Itens/Types/template-struct";
import { TemplateItemType } from "@/models/Blocks/Itens/Types/template-item-type";
import { BlockItem } from "@/models/Blocks/Itens/block-item";
import { BlockFactory } from "@/models/Blocks/Itens/block-factory";

//Templates
import { templates } from '@/models/Blocks/Definitions/templates';

interface ApplyStruct{
    index: number;
    struct: TemplateStruct
}


export class BlockStruct {
    protected _struct?: any[][][];
    protected _objects: any[]|{[key: string]: object};
    protected _templates: any;
    protected _repeat: boolean = false;
    protected _elemNotFound: boolean = false;
    protected _skeleton: boolean = false;
    protected _blockName?: string;
    protected _key?: string;

    public constructor(struct: any[][][]|String, objects: Array<object>|{[key: string]: object}, repeatStruct: boolean = false) {
        this._struct = struct instanceof String || typeof struct == 'string' ? BlockStruct.getTemplate(struct.toString()) : struct;
        this._objects = objects;
        this._repeat = repeatStruct;
    }

    public get skeleton(): boolean {
        return this._skeleton;
    }

    public set skeleton(value: boolean){
        this._skeleton = value;
    }

    public get key(): string|undefined{
        return this._key;
    }

    public set key(value: string){
        this._key = value;
    }

    public get blockName(): string|undefined {
        return this._blockName;
    }

    public set blockName(value: string|undefined){
        this._blockName = value;
    }

    public static getTemplate(templateName: string): any[][][] {
        return templates[templateName] ?? [[[]]];
    }

    public getStruct(properties: {[key: string]: any}|undefined = undefined): TemplateStruct {
        let template:TemplateStruct  =  new TemplateStruct();
        if(!this._struct){
            return template;
        }
        let index = 0;
        let limit = Array.isArray(this._objects) ? this._objects.length : 0;
        do {
            let rst = this._applyStruct(index,this._struct, properties);
            index = rst.index;
            if(template.rows.length > 0){
                let t = new TemplateStruct();
                t.rows = [...template.rows,...rst.struct.rows];
                template = t;
            }else{
                template = rst.struct;
            }
        } while (this._repeat && index < limit);

        if(this.key){
            template.key = this.key;
        }

        return template;
    }

    /**
     * Apply template struct to elements
     * 
     * @param index 
     * @param struct 
     * @returns 
     */
    protected _applyStruct(index: number, struct?: any[][][], properties: {[key: string]: any}|undefined = undefined): ApplyStruct{
        let template:TemplateStruct  =  new TemplateStruct();
        if(!struct){
            return {index: index, struct: template};
        }
        let propsValues: Array<any> = Object.values(properties??{});
        let grid: number|null = propsValues && propsValues.length > 0 ? propsValues[0].grid ?? null : null;
        if(grid){
            template.cols = grid;
        }
        struct.forEach((row: any[]) => {
            let r: TemplateStructRow = {cols: []};
            let notFound = false;
            row.forEach((col: any[]) => {
                let c: TemplateStructCol = {itens: []};
                col.forEach((value: string|{type: string, id: string, data?: any[][][], bgColor?: string}) => {

                    if(typeof value != 'string' && value.type.toUpperCase() == 'T' && value.data){
                        let rst = this._applyStruct(index,value.data, properties);
                        if(rst.struct.rows.length > 0){
                            let colWidth: number = rst.struct.rows[0].cols.reduce((accumulator, object) => {
                                return accumulator + (object.width ?? 0);
                            },0);
                            index = rst.index;
                            if(colWidth){
                                c.width = colWidth;
                            }
                            c.itens.push(rst.struct);
                        }else{
                            notFound = true;
                        }
                    }else{
                        let item: any|null =  this._getItem(value,index);
                        let bItem: BlockItem|null = item ? BlockFactory.get(item) : null;
                        let id: any|null = typeof value != 'string' ? value?.id??null : null;
                        let colWidth: number|null = id && properties ? properties[id]?.gridW : null;
                        if(bItem){
                            let t = typeof value == 'string' ? value : value.type;
                            let bgColor = typeof value == 'string' ? null : value.bgColor;
                            bItem.blockName = this.blockName;
                            bItem.blockKey = this.key;
                            if(id){
                                bItem.positionKey = id;
                            }
                            bItem.templateType = BlockStruct.getItemType(t);
                            if(bgColor){
                                bItem.backgroundColor = bgColor;
                            }
                            if(colWidth){
                                c.width = colWidth;
                            }
                            c.itens.push(bItem);
                        }else{
                            notFound = !this._repeat;
                        }
                    }
                    index++;
                });
                r.cols.push(c);
            });
            if(!notFound){
                template.rows.push(r);
            }else{
                this._elemNotFound = true; //TODO
            }
        });
        return {index: index, struct: template};
    }

    protected _getItem(item: string|{type: string, id: string}, index: number):any|null{
        if(this.skeleton){
            return {
                skeleton: true
            };
        }
        if(typeof item == 'string' && Array.isArray(this._objects)){
            return this._objects.length > index ? this._objects[index] : null;
        }
        if(typeof item == 'object' && !Array.isArray(this._objects)){
            return this._objects[item.id] ?? null;
        }
        return null;
    }

    public static getItemType(value: string): TemplateItemType {
        switch(value.toLowerCase()) {
            case 's':
                return TemplateItemType.square;
            case 'h':
                return TemplateItemType.horizontal;
            case 'v':
                return TemplateItemType.vertical;
            default:
                return TemplateItemType.square;
        }
    }
}